import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const categories = [
  { name: 'Shoes', url: 'https://kaspreadsheet.com/category-911-Shoes.html', icon: 'ri-footprint-line' },
  { name: 'Hoodies/Sweaters', url: 'https://kaspreadsheet.com/search-912/name/Shoes.html', icon: 'ri-shirt-line' },
  { name: 'T-Shirts', url: 'https://kaspreadsheet.com/search-913/name/Shoes.html', icon: 'ri-t-shirt-line' },
  { name: 'Jackets', url: 'https://kaspreadsheet.com/search-914/name/Shoes.html', icon: 'ri-shirt-line' },
  { name: 'Pants/Shorts', url: 'https://kaspreadsheet.com/search-915/name/Shoes.html', icon: 'ri-shield-user-line' },
  { name: 'Headwear', url: 'https://kaspreadsheet.com/search-916/name/Shoes.html', icon: 'ri-user-3-line' },
  { name: 'Sets', url: 'https://kaspreadsheet.com/search-917/name/Shoes.html', icon: 'ri-layout-grid-line' },
  { name: 'Underwear/Underpants', url: 'https://kaspreadsheet.com/search-918/name/Shoes.html', icon: 'ri-shirt-line' },
  { name: 'Jersey', url: 'https://kaspreadsheet.com/search-919/name/Shoes.html', icon: 'ri-t-shirt-line' },
  { name: 'Accessories', url: 'https://kaspreadsheet.com/search-920/name/Shoes.html', icon: 'ri-glasses-line' },
  { name: 'Bags', url: 'https://kaspreadsheet.com/search-921/name/Shoes.html', icon: 'ri-shopping-bag-line' },
  { name: 'Belts', url: 'https://kaspreadsheet.com/search-922/name/Shoes.html', icon: 'ri-link' },
  { name: 'Perfumes', url: 'https://kaspreadsheet.com/search-923/name/Shoes.html', icon: 'ri-drop-line' },
  { name: 'Other Stuff', url: 'https://kaspreadsheet.com/search-924/name/Shoes.html', icon: 'ri-more-line' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [mobileCatOpen, setMobileCatOpen] = useState(false);

  useEffect(() => {
    function handleScroll() {
      setScrolled(window.scrollY > 60);
    }
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-white/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-black/30 backdrop-blur-md'
      }`}
    >
      <div className="w-full px-4 md:px-10">
        <div className="flex items-center justify-between h-16 md:h-18">
          <Link
            to="/"
            className="flex items-center gap-2.5 cursor-pointer whitespace-nowrap"
          >
            <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
              <i className="ri-leaf-line text-white text-lg"></i>
            </div>
            <span className={`font-heading text-lg font-semibold ${scrolled ? 'text-foreground-900' : 'text-white'}`}>
              Itaobuy Sheet
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-3">
            <Link
              to="/"
              className={`text-sm font-medium whitespace-nowrap cursor-pointer transition-colors ${scrolled ? 'text-foreground-600 hover:text-foreground-900' : 'text-white/90 hover:text-white'}`}
            >
              <i className="ri-home-4-line mr-1 text-sm"></i>
              Home
            </Link>

            <div className="relative group">
              <button
                className={`flex items-center gap-1.5 text-sm font-medium whitespace-nowrap cursor-pointer transition-colors ${scrolled ? 'text-foreground-600 hover:text-foreground-900' : 'text-white/90 hover:text-white'}`}
              >
                <i className="ri-price-tag-3-line mr-0.5 text-sm"></i>
                Categorie
                <i className="ri-arrow-down-s-line text-xs"></i>
              </button>
              <div className="absolute top-full left-0 mt-2 w-72 bg-white rounded-xl border border-background-200/70 overflow-hidden opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-50 shadow-lg">
                <div className="py-2 max-h-80 overflow-y-auto">
                  {categories.map((cat, idx) => (
                    <a
                      key={idx}
                      href={cat.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="flex items-center gap-3 px-4 py-2.5 text-sm text-foreground-700 hover:bg-accent-50 hover:text-foreground-900 transition-colors duration-150 cursor-pointer whitespace-nowrap"
                    >
                      <i className={`${cat.icon} text-primary-500 text-base w-5 h-5 flex items-center justify-center`}></i>
                      {cat.name}
                    </a>
                  ))}
                </div>
              </div>
            </div>

            <Link
              to="/#articoli"
              className={`text-sm font-medium whitespace-nowrap cursor-pointer transition-colors ${scrolled ? 'text-foreground-600 hover:text-foreground-900' : 'text-white/90 hover:text-white'}`}
            >
              <i className="ri-book-open-line mr-1 text-sm"></i>
              Guida agli Acquisti
            </Link>

            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className={`text-sm font-medium whitespace-nowrap cursor-pointer transition-colors ${scrolled ? 'text-foreground-600 hover:text-foreground-900' : 'text-white/90 hover:text-white'}`}
            >
              Itaobuy Sheet
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="ml-1 px-5 py-2.5 rounded-full bg-primary-500 text-white text-sm font-semibold hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              Buy It Now
              <i className="ri-arrow-right-up-line ml-1.5 text-sm"></i>
            </a>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center rounded-lg cursor-pointer ${scrolled ? 'text-foreground-700' : 'text-white'}`}
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-white/97 backdrop-blur-xl border-t border-background-200/70 px-5 py-5 flex flex-col gap-1 max-h-[75vh] overflow-y-auto">
          <Link
            to="/"
            onClick={() => setMobileOpen(false)}
            className="flex items-center gap-3 text-sm text-foreground-700 py-3 px-3 rounded-lg hover:bg-background-100 cursor-pointer"
          >
            <div className="w-8 h-8 rounded-lg bg-primary-100 flex items-center justify-center">
              <i className="ri-home-4-line text-primary-600 text-base"></i>
            </div>
            <span className="font-medium">Home</span>
          </Link>

          <div>
            <button
              onClick={() => setMobileCatOpen(!mobileCatOpen)}
              className="flex items-center justify-between w-full gap-3 text-sm text-foreground-700 py-3 px-3 rounded-lg hover:bg-background-100 cursor-pointer"
            >
              <div className="flex items-center gap-3">
                <div className="w-8 h-8 rounded-lg bg-accent-100 flex items-center justify-center">
                  <i className="ri-price-tag-3-line text-accent-600 text-base"></i>
                </div>
                <span className="font-medium">Categorie</span>
              </div>
              <i className={`ri-arrow-down-s-line text-foreground-400 transition-transform ${mobileCatOpen ? 'rotate-180' : ''}`}></i>
            </button>
            {mobileCatOpen && (
              <div className="grid grid-cols-2 gap-1 pl-11 pr-3 pb-2">
                {categories.map((cat, idx) => (
                  <a
                    key={idx}
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    onClick={() => setMobileOpen(false)}
                    className="flex items-center gap-2 text-xs text-foreground-600 hover:text-primary-600 py-2 px-2 rounded-md hover:bg-background-100 cursor-pointer whitespace-nowrap"
                  >
                    <i className={`${cat.icon} text-primary-500 text-xs w-4 h-4 flex items-center justify-center`}></i>
                    {cat.name}
                  </a>
                ))}
              </div>
            )}
          </div>

          <Link
            to="/#articoli"
            onClick={() => setMobileOpen(false)}
            className="flex items-center gap-3 text-sm text-foreground-700 py-3 px-3 rounded-lg hover:bg-background-100 cursor-pointer"
          >
            <div className="w-8 h-8 rounded-lg bg-secondary-100 flex items-center justify-center">
              <i className="ri-book-open-line text-secondary-600 text-base"></i>
            </div>
            <span className="font-medium">Guida agli Acquisti</span>
          </Link>

          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            onClick={() => setMobileOpen(false)}
            className="flex items-center gap-3 text-sm text-primary-600 font-semibold py-3 px-3 rounded-lg hover:bg-primary-50 cursor-pointer"
          >
            <div className="w-8 h-8 rounded-lg bg-primary-100 flex items-center justify-center">
              <i className="ri-external-link-line text-primary-600 text-base"></i>
            </div>
            <span>Itaobuy Sheet</span>
          </a>

          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            onClick={() => setMobileOpen(false)}
            className="mt-2 px-5 py-3 rounded-full bg-primary-500 text-white text-sm font-semibold text-center hover:bg-primary-600 transition-colors cursor-pointer"
          >
            Buy It Now
            <i className="ri-arrow-right-up-line ml-1.5 text-sm"></i>
          </a>
        </div>
      )}
    </nav>
  );
}